/**
 * Where the country the consent gate was started with came from: `filters`
 * when the /api/v2/filters response supplied it, `fallback` when that failed
 * and the default country stood in, `none` before either.
 */
export type ConsentCountrySource = 'filters' | 'fallback' | 'none'

let source: ConsentCountrySource = 'none'

export function setConsentCountrySource(next: ConsentCountrySource): void {
  source = next
}

export function consentCountrySource(): ConsentCountrySource {
  return source
}

export function resetConsentCountrySourceForTests(): void {
  source = 'none'
}
